import { initI18n } from '@bluecodecom/i18n';

export const RESOURCES = {
  en: {
    translation: {},
  },
  de: {
    translation: {},
  },
} as const;

initI18n(RESOURCES, {
  interpolation: {
    escapeValue: false,
  },
});
